'use client';

import {
  Field as ChakraField,
  Textarea,
  type TextareaProps,
} from '@chakra-ui/react';
import type { Control, FieldErrors, UseFormRegister } from 'react-hook-form';
import { Field, type FieldProps } from './field';

interface FormTextAreaProps
  extends TextareaProps, Omit<FieldProps, keyof TextareaProps> {
  label: string;
  id: string;
  register: UseFormRegister<any>;
  control: Control<any>;
  errors: FieldErrors;
  showLabelAtTop?: boolean;
}

const FormInput: React.FC<FormTextAreaProps> = ({
  label,
  id,
  register,
  control,
  errors,
  disabled,
  helperText,
  isShowLabel = true,
  disableLabel = false,
  labelProps,
  showLabelAtTop = false,
  required = false,
  optionalText,
  ...rest
}) => {
  return (
    <Field
      label={!showLabelAtTop && label}
      invalid={!!errors?.[id]}
      id={id}
      errorText={errors?.[id]?.message as string}
      disabled={disabled}
      helperText={helperText}
      isShowLabel={isShowLabel}
      disableLabel={disableLabel}
      labelProps={labelProps}
      required={required}
      optionalText={optionalText}
    >
      {showLabelAtTop && label && (
        <ChakraField.Label mb={2} color="tertiary.fg">
          {label} <ChakraField.RequiredIndicator fallback={optionalText} />
        </ChakraField.Label>
      )}
      <Textarea
        id={id}
        {...register(id)}
        name={id}
        autoresize
        placeholder={`Write ${label || id}...`}
        disabled={disabled}
        {...rest}
      />
    </Field>
  );
};

export default FormInput;
